import { Environments } from '@/config';
import { HELIX_NEBRASKA_PRODUCTION } from './helix-nebraska.production';
import { HELIX_NEBRASKA_STAGING } from './helix-nebraska.staging';

export const HELIX_NEBRASKA =
  import.meta.env.MODE === Environments.PROD ? HELIX_NEBRASKA_PRODUCTION : HELIX_NEBRASKA_STAGING;
